// Logo.tsx
export function Logo() {
  return (
    <div className="text-xl font-semibold tracking-tight">
      Qneect
    </div>
  );
}
